import {
    Box,
    Typography,
    FormControl,
    Select,
    MenuItem,
    Button,
    FormControlLabel,
    Checkbox,
    Tabs,
    Tab,
    useTheme,
    useMediaQuery,
    FormGroup,
    styled,
    Switch,
    ToggleButtonGroup,
    ToggleButton
} from '@mui/material';
import { Replay, ShortSubject, SubjectIcon } from '../../../../Assets/Svg/Svg';
import { useState } from 'react';
import RSColorPicker from './RsColorPicker';


const toneOptions = [
    { value: 'professional', label: 'Professional' },
    { value: 'friendly', label: 'Friendly' },
    { value: 'concise', label: 'Concise' },
    { value: 'detailed', label: 'Detailed' },
];

function CommentSettings(props) {
    const { selectedTone, onToneChange, includeRecommendation, onRecommendationChange, tabValue, setTabValue, lastBtn, handleNext, card } = props;
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedColor, setSelectedColor] = useState("#334B8E");
    const [isChanged, setIsChanged] = useState(false);
    const [highlightEnabled, setHighlightEnabled] = useState(false); // state for switch
    const colorPalette = ["#6C2181", "#851313", "#C64B00", "#195803", "#0E4D5C", "#2F0881", "#038787", "#475803", "#571E1E", "#334B8E"];

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 37,
        height: 19, // overall switch height
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2.5,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(20px)', // adjust for new size
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#239D80',
                    opacity: 1,
                    border: 0,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 14,  // thumb size to match height
            height: 14,
        },
        '& .MuiSwitch-track': {
            borderRadius: 34 / 2, // match height
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    return (
        <Box>
            <Typography sx={{ mb: 1, mt: 1, color: '#757575' }}>
                Comment preferences
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                <Box display={"flex"} gap={1} flexDirection={isMobile ? "column" : "row"}>
                    <ToggleButtonGroup
                        value={tabValue}
                        exclusive
                        sx={{
                            height: "38px",
                            textTransform: "capitalize",
                            "& .MuiToggleButton-root": {
                                color: "#454545", 
                                "&.Mui-selected": {
                                    color: "#454545", 
                                    backgroundColor: "#F0F6FF",
                                },
                            },
                        }}
                        onChange={(e, newValue) => {
                            if (newValue !== null) {
                                setTabValue(newValue);
                            }
                        }}
                        aria-label="Platform"
                    >
                        <ToggleButton value="Short" sx={{ textTransform: "capitalize" }}>
                            <ShortSubject /> Short
                        </ToggleButton>

                        <ToggleButton value="Long" sx={{ textTransform: "capitalize" }}>
                            <SubjectIcon /> Long
                        </ToggleButton>
                    </ToggleButtonGroup>

                    <Box display="flex" alignItems="center" gap={0.5} className="box_recommendation">
                        <Checkbox
                            checked={includeRecommendation}
                            onChange={(e) => onRecommendationChange(e.target.checked)}
                            size="small"
                            sx={{ height: "20px !important", width: "20px !important", marginLeft: "5px !important" }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: "14px !important",
                                color: "#454545 !important",
                                textAlign:"center !important",
                                alignItems: "center !important",
                            }}
                            className='Include_recommendation'
                        >
                            Include recommendation
                        </Typography>
                    </Box>
                </Box>

                {lastBtn &&
                    <Button
                        size='small'
                        variant="contained"
                        startIcon={<Replay />}
                        sx={{
                            fontSize: "14px",
                            border: "1px solid #4282E2",
                            backgroundColor: "#FFFF",
                            color: "#4282E2",
                            boxShadow: "none",
                            marginLeft: "5px",
                            marginBottom: "13px",
                            px: 1.5,
                            fontWeight: 700,
                            '&:hover': {
                                backgroundColor: "#e0efff",
                                boxShadow: "none"
                            }
                        }}
                        onClick={() => handleNext(true, card)}
                    >
                        Retry
                    </Button>
                }
            </Box>

            {/* Switch for highlight */}
            {/* <FormControlLabel
                control={
                    <IOSSwitch
                        sx={{ margin: "10px 10px 10px 0px" }}
                        checked={highlightEnabled}
                        onChange={(e) => setHighlightEnabled(e.target.checked)}
                    />
                }
                label="Highlight findings"
                sx={{
                    '& .MuiFormControlLabel-label': {
                        color: '#3B3B3B',
                        fontSize: '14px',
                        fontWeight: 400,
                    }
                }}
            /> */}

            {/* Color picker section (disabled when switch is off) */}
            {/* <div
                style={{
                    padding: "0px 50px",
                    opacity: highlightEnabled ? 1 : 0.5,
                    pointerEvents: highlightEnabled ? "auto" : "none",
                }}
            >
                <Typography color={'#757575'}>Color</Typography>
                <RSColorPicker
                    color={selectedColor}
                    setColor={setSelectedColor}
                    setIsChanged={setIsChanged}
                    colorPalette={colorPalette}
                />
            </div> */}
        </Box>
    );
};

export default CommentSettings;
